import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

const ContextmenuButtons = (props) => {
  const {handleItemClick, pos, contextMenuButtons} = props;

  //   todo sqft-react close
  //   const disallowClasses = [".contextmenu-buttons", ".contextmenu-buttons__button"];
  //   if (event.target && !disallowClasses.some(cls => event.target.closest(cls))) {
  //     this.closeContextMenu();
  //   }
  //
  // };

  const getContextMenuPosition = (pos) => {
    return {
      left: pos.x + "px",
      top: pos.y + "px"
    };
  };

  const getMaxWidth = () => {
    let maxWidth = {};
    switch (contextMenuButtons.length) {
      case 4:
        maxWidth = { maxWidth: "210px"}; break;
      case 5:
      default:
        maxWidth = { maxWidth: "310px"}; break;
    }

    return maxWidth
  };

  return(
    <div id="contextmenu" className="contextmenu" style={{...getContextMenuPosition(pos), ...getMaxWidth()}}>
      <div className="contextmenu-buttons">
        {
          contextMenuButtons.map((menuItem, index) => {
            return (
              <button
                key={index}
                data-part-id = "menuItem.partId"
                data-text = "  menuItem.text  "
                className = {"contextmenu-buttons__button contextmenu-buttons__button--" +
                menuItem.partId.toLowerCase().replace(/ /g,"-")}
                onClick={(e) => handleItemClick(e, menuItem)}
              >
                <span className="contextmenu-buttons__button-text">
                  <FormattedMessage id={menuItem.text}/>
                </span>
              </button>
            );
          })
        }
      </div>
    </div>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextmenuButtons);

